import { render } from "./CopySection.vue?vue&type=template&id=507e5462&scoped=true&ts=true"
import script from "./CopySection.vue?vue&type=script&lang=ts"
export * from "./CopySection.vue?vue&type=script&lang=ts"

import "./CopySection.vue?vue&type=style&index=0&id=507e5462&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507e5462"]])

export default __exports__